// A slot that ends past midnight (e.g. 23:45 - 00:05 for a venue with a 5 minute offset) ends on the
// next day, so its end time is moved past 24:00:00 to compare correctly with same-day times.
export const getEndTimeAfterStart = (startTime: string, endTime: string) => {
  if (endTime > startTime) return endTime;

  const hours = String(Number(endTime.slice(0, 2)) + 24).padStart(2, '0');
  return `${hours}${endTime.slice(2)}`;
};
